import React from 'react';
import { useTheme } from 'styled-components/macro';
import { StyledLabel, StyledParagraph } from './styled';
import { ILabelProps } from './types';
import { FormikLabelInfo } from 'lib/components/formik/FormikInfoTooltip';

export const Label: React.FC<ILabelProps> = ({
  name,
  label,
  isRequired,
  disabled,
  extendStyles,
  info,
  tooltipPosition,
}) => {
  const themes = useTheme();

  if (!name) {
    return (
      <StyledLabel
        htmlFor={name}
        disabled={disabled}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '2px',
          ...extendStyles,
        }}
      >
        {label}
        {isRequired && (
          <span style={{ color: themes.colors.primary[100] }}>*</span>
        )}
        {info && (
          <FormikLabelInfo info={info} tooltipPosition={tooltipPosition} />
        )}
      </StyledLabel>
    );
  }
  return (
    <StyledParagraph
      disabled={disabled}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '2px',
        ...extendStyles,
      }}
    >
      {label}
      {isRequired && (
        <span style={{ color: themes.colors.primary[100] }}>*</span>
      )}
      {info && (
        <FormikLabelInfo info={info} tooltipPosition={tooltipPosition} />
      )}
    </StyledParagraph>
  );
};
